import { DatabaseService, Report, ReportData } from "@/core";
import { ReportRepository } from "@/core/ports/repositories/report-repository";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getReportRepository(
  databaseService: DatabaseService,
): ReportRepository {
  return getGenericRepository<Report, ReportData>(
    () => DatabaseCollection.REPORTS,
    databaseService,
  );
}
